module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Title":"Titel","URL Key":"URL Schlüssel","Copy URL":"URL kopieren","URL copied to clipboard!":"URL wurde in die Zwischenablage kopiert!","URL could not be copied.":"URL konnte nicht kopiert werden."}}')
  delete Component.options._Ctor
}
